import React, { JSX } from 'react';
import { Col, Row } from 'reactstrap';
import { ApiImportantInfo } from '@ibe/api';
import PackageImportantInfoPanel from './PackageImportantInfoPanel';

interface Props {
  importantInfo?: ApiImportantInfo[];
}

const ImportantInfo = (props: Props): JSX.Element => {
  const { importantInfo } = props;
  return (
    <Row className="justify-content-start">
      {importantInfo &&
        importantInfo.length > 0 &&
        importantInfo.map(
          (info): JSX.Element => {
            return (
              <Col md={6} className="my-2" key={info.title}>
                <PackageImportantInfoPanel title={info.title} text={info.text} />
              </Col>
            );
          }
        )}
    </Row>
  );
};

export default ImportantInfo;
